import ApiClient from './apiClient'
import {
  Login,
  GoogleCallbackUrl,
  MicrosoftCallbackUrl,
  ResetRequest,
  ResetPassword,
  ClientVersion,
} from '../types/auth'
import { MasterMember } from '../types/masterLogin'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postLogin = async (login: Login): Promise<any> => ApiClient.post_without_token(
  '/api/auth/login',
  (result: Login) => result,
  login,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postMasterLogin = async (login: Login): Promise<any> => ApiClient.post_without_token(
  '/api/v1/management/vP7zNSodL1/login',
  (result: Login) => result,
  login,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMfaToken = async (login: Login): Promise<any> => ApiClient.post_without_token(
  '/api/auth/mfa_login',
  (result: Login) => result,
  login,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postMasterLoginManagement = async (memberId: { member_id: number }): Promise<any> => ApiClient.post(
  '/api/v1/management/vP7zNSodL1/login_management',
  (result: Login) => result,
  memberId,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMasterMember = async (): Promise<any> => ApiClient.get(
  '/api/v2/management/vP7zNSodL1/member',
  (result: MasterMember) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getAccessToken = async (): Promise<any> => ApiClient.get_without_token(
  '/api/auth/access_token',
  (result: Login) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postLogout = async (): Promise<any> => ApiClient.post(
  '/api/v1/renderer/logout',
  (result: Record<string, unknown>) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postMicrosoftSync = async (): Promise<any> => ApiClient.post(
  '/api/v2/renderer/login/microsoft/sync',
  (microsoftLoginUrl: string) => microsoftLoginUrl,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postMicrosoftZendesk = async (): Promise<any> => ApiClient.post(
  '/api/v2/renderer/login/microsoft/zendesk',
  (microsoftLoginUrl: string) => microsoftLoginUrl,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postMicrosoftLink = async (params: MicrosoftCallbackUrl): Promise<any> => ApiClient.post(
  '/api/v2/renderer/login/microsoft/link',
  (result: string) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postGoogleSync = async (): Promise<any> => ApiClient.post(
  '/api/v2/renderer/login/google/sync',
  (googleLoginUrl: string) => googleLoginUrl,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postGoogleZendesk = async (): Promise<any> => ApiClient.post(
  '/api/v2/renderer/login/google/zendesk',
  (googleLoginUrl: string) => googleLoginUrl,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postGoogleLink = async (params: GoogleCallbackUrl): Promise<any> => ApiClient.post(
  '/api/v2/renderer/login/google/link',
  (result: string) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postResetPassword = async (params: ResetRequest): Promise<any> => ApiClient.post(
  '/api/v1/features/password/reset',
  (result: string) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchResetPassword = async (params: ResetPassword): Promise<any> => ApiClient.patch(
  '/api/v1/features/password/reset',
  (result: string) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getClientVersion = async (): Promise<any> => ApiClient.get_self(
  `/version.json?${new Date().getTime()}`,
  (result: ClientVersion) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getZendeskToken = async (): Promise<any> => ApiClient.get(
  '/api/auth/zendesk_token',
  (result: string) => result,
)
